import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from 'src/app/authentication/service/security.service';
import { SnackbarService } from 'src/app/mobile-application-manager/service/snackbar.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private securityService: SecurityService
  ) {

    securityService.signOut();

  }

  ngOnInit(): void {
  }
  requestGoogleLogin(): void {
    this.securityService.login();
  }
}
